"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFindingOutputDtoSchema = exports.updateFindingInputDtoSchema = void 0;
const z = __importStar(require("zod"));
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const claimInputSchema = sigma_engine_shared_1.UpdateClaimInputSchema.extend({
    id: z.string(),
});
const designObjectTagInputSchema = z.object({
    id: z.string(),
    type: sigma_engine_shared_1.DesignObjectTypeSchema,
    reference: z.string(),
});
const updateFindingData = {
    type: z.nativeEnum(sigma_engine_shared_1.FindingType),
    projectId: z.string().optional(),
    status: sigma_engine_shared_1.FindingStatusSchema.optional(),
    isReviewed: z.boolean().optional(),
    title: z.string().optional(),
    description: z.string().optional(),
    sources: claimInputSchema.array().optional(),
    sinks: claimInputSchema.array().optional(),
    connections: claimInputSchema.array().optional(),
    claims: claimInputSchema.array().optional(),
    requirementResultIds: z.string().array().optional(),
    designObjectTags: designObjectTagInputSchema.array().optional(),
};
const updateFindingInput = {
    id: z.string(),
    data: z.object(updateFindingData),
};
exports.updateFindingInputDtoSchema = z.object(updateFindingInput);
const updateFindingOutput = {
    finding: sigma_engine_shared_1.FindingSchema.nullable(),
};
exports.updateFindingOutputDtoSchema = z.object(updateFindingOutput);
//# sourceMappingURL=update-finding.dto.js.map